
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryHorizontal50 as ObiBatteryHorizontal50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-horizontal-50.js';
 
 
 

 
 export const ObiBatteryHorizontal50 = createComponent({
   react: React,
   tagName: 'obi-battery-horizontal-50',
   elementClass: ObiBatteryHorizontal50Element,
   events: {
     
   }
  });
 
 